/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTimecardTransactions} from '../api'

 export const useQueryGetTimecardTransactions = createReactQueryHook('getTimecardTransactions', getTimecardTransactions)
